import {
	formatGenres,
	formatEventState,
	formatAvailabilityDate,
} from '@/lib/formaters';
import { formatImage } from './formatImage';

/**
 *
 * @param event
 * @param locale The current locale code
 * @returns
 */
export const formatEventCalendar = (datas, locale = 'en-US') => {
	const eventDate = new Date(datas.date.replace(/-/g, '/')); // `.replace(/-/g, '/')` is to fix safari which fails parsing xxxx-xx-xx date format
	const now = new Date();
	const endDate = new Date(datas.event.endDate.replace(/-/g, '/')); // `.replace(/-/g, '/')` is to fix safari which fails parsing xxxx-xx-xx date format

	const availability = formatAvailability(
		datas.state,
		datas.availabilityLevel
	);

	return {
		id: datas.event.id,
		label:
			datas.event.acf.card?.label?.title ||
			datas.event.acf.card?.label?.text
				? {
						title: datas.event.acf.card?.label?.title ?? null,
						text: datas.event.acf.card.label.text ?? null,
				  }
				: null,
		artist: datas.event.uptitle,
		title: datas.event.title,
		link: datas.event.acf?.hasDetailPage ? datas.event.link : null,
		time:
			`${eventDate.getHours()}${eventDate.getMinutes()}` === '00'
				? null
				: eventDate.toLocaleTimeString(locale, {
						hour: '2-digit',
						minute: '2-digit',
				  }),
		duration: datas.event.acf.duration,
		location: datas?.location?.name ?? '',
		genres: formatGenres(
			datas.event.genres.nodes
				.map(({ translation: t }) => t)
				.filter(Boolean),
			datas.event.acf.specialMention,
			!!datas.event.acf.production?.length
		),
		availability,
		availability_date:
			availability === 'soon'
				? formatAvailabilityDate(datas.availabilityDate, locale)
				: null,
		date: eventDate,
		ticketsLink:
			endDate.getTime() >= now.getTime()
				? datas.uri || datas.event.acf.ticketLink
				: null,
		ticketButtonText:
			datas?.uriLabel && datas.uriLabel !== ''
				? datas.uriLabel
				: datas.event.acf.ticketButtonText ?? null,
		state: formatEventState(datas.state),
		isEvent: datas.event.acf.isEvent,
		isAroundTheShow: datas.event.acf.isAroundTheShow,

		// Needed for filters
		thematics: datas.event.thematics.nodes.map(({ translation: t }) => t),
		seasons: datas.event.seasons.nodes.map(({ translation: t }) => t),
		publics:
			datas.event.acf.publics?.nodes.map(
				({ id, title, icon: { img } }) => ({
					id,
					title,
					icon: formatImage(img),
				})
			) ?? [],
	};
};

/**
 * Format availability
 * @param state
 * @returns 'high' | 'low' | 'none' | 'soon' | 'no-state'
 */
export const formatAvailability = (state, level) => {
	switch (state) {
		case 'ON_SALE':
		case 'RUNNING':
		case 'VALIDATED':
			switch (level) {
				case 'GOOD':
					return 'high';

				case 'LIMITED':
					return 'low';

				case 'NO_STATE':
					return 'no-state';
					
				case 'NONE':
				default:
					return 'none';
			}
		case 'SOON_ON_SALE':
			return 'soon';
		default:
			return 'none';
	}
};
